import {
  getDrivesStart,
  getDrivesSuccess,
  getDrivesFailure,
  setSelectedDriveName,
  setFilteredDrivesList,
  setSelectedDriveVideoURL,
  setSelectedDriveID,
  deleteDriveStart,
  deleteDriveSuccess,
  deleteDriveFailure,
  getStorageUrl,
  resetStorageUrl,
  clearDrives,
  drivesStateStart,
  drivesStateSuccess,
  drivesStateFailure,
} from './drive.slice';
import {
  fetchDrivesApi,
  fetchDrivesByCompanyApi,
  driveDeleteApi,
  fetchDriveStorageUrl,
  getCollectionDrivesApi,
  fetchDrivesStateApi,
} from '../api/drive.api';

export const fetchDrives = (collectionId) => async (dispatch) => {
  dispatch(getDrivesStart());
  try {
    const response = await fetchDrivesApi(collectionId);
    dispatch(getDrivesSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getDrivesFailure(error.response.data));
    throw error;
  }
};
export const fetchDrivesByCompany = (companyid) => async (dispatch) => {
  dispatch(getDrivesStart());
  try {
    const response = await fetchDrivesByCompanyApi(companyid);
    dispatch(getDrivesSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getDrivesFailure(error.response.data));
    throw error;
  }
};

// new thunk: fetch drives by collection id (sends collectionID in request body)
export const fetchDrivesByCollection = (collectionId) => async (dispatch) => {
  dispatch(getDrivesStart());
  try {
    const response = await getCollectionDrivesApi(collectionId);
    dispatch(getDrivesSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(getDrivesFailure(error.response.data));
    throw error;
  }
};

export const fetchDrivesByCollectionForModal = (collectionId) => async () => {
  const response = await getCollectionDrivesApi(collectionId);
  return response;
};

export const fetchSelectedDriveStorageUrl = (driveId) => async (dispatch) => {
  const response = await fetchDriveStorageUrl(driveId);
  dispatch(getStorageUrl(response.data));
  return response.data;
};

export const resetDriveStorageUrlState = () => async (dispatch) => {
  dispatch(resetStorageUrl());
};

export const deleteDrive = (driveid) => async (dispatch) => {
  dispatch(deleteDriveStart());
  try {
    const response = await driveDeleteApi(driveid);
    dispatch(deleteDriveSuccess());
    return response.data;
  } catch (error) {
    dispatch(deleteDriveFailure(error.response.data));
  }
};

export const setDashboardDriveName = (drive) => async (dispatch) => {
  dispatch(setSelectedDriveName(drive));
};

export const clearDrivesAction = () => async (dispatch) => {
  dispatch(clearDrives());
};

export const setDriveVideoURL = (drive) => async (dispatch) => {
  dispatch(setSelectedDriveVideoURL(drive));
};

export const setFilteredDrives = (drives) => async (dispatch) => {
  dispatch(setFilteredDrivesList(drives));
};

export const setDriveID = (driveid) => async (dispatch) => {
  dispatch(setSelectedDriveID(driveid));
};

export const fetchDrivesState = (stateName) => async (dispatch) => {
  dispatch(drivesStateStart());
  try {
    const response = await fetchDrivesStateApi(stateName);
    dispatch(drivesStateSuccess(response.data));
    return response;
  } catch (error) {
    dispatch(drivesStateFailure(error.response.data));
    throw error;
  }
};
